import { Box, Progress } from "@chakra-ui/react";
import { wpStyles } from "../../theme/wp-styles";

const PageLoader = () => {
  return <Box h="100vh"></Box>;
};

export default PageLoader;
